import React from "react";
import plus from '../../assets/icons/shapes/plus.png';
import polygon from '../../assets/icons/shapes/polygon.png';
import square from '../../assets/icons/shapes/square.png';
import crown from '../../assets/icons/shapes/crown.png';
import diamond from '../../assets/icons/shapes/diamond.png';
import star from '../../assets/icons/shapes/star.png';
import thin_star from '../../assets/icons/shapes/thin_star.png';
import plus_out from '../../assets/icons/out_shapes/plus_out.png';
import polygon_out from '../../assets/icons/out_shapes/polygone_out.png';
import rectangle_out from '../../assets/icons/out_shapes/rectangle_out.png';
import crown_out from '../../assets/icons/out_shapes/crown_out.png';
import diamond_out from '../../assets/icons/out_shapes/diamond_out.png';
import star_out from '../../assets/icons/out_shapes/star_out.png';
import thin_star_out from '../../assets/icons/out_shapes/thin_star_out.png';
import Gems from "../../components/Gems/Gems";

const gemData = [
    { name: "Plus", icon: plus, outIcon: plus_out, count: 3 },
    { name: "Polygon", icon: polygon, outIcon: polygon_out, count: 0 },
    { name: "Square", icon: square, outIcon: rectangle_out, count: 5 },
    { name: "Crown", icon: crown, outIcon: crown_out, count: 0 },
    { name: "Diamond", icon: diamond, outIcon: diamond_out, count: 8 },
    { name: "Star", icon: star, outIcon: star_out, count: 0 },
    { name: "Thin Star", icon: thin_star, outIcon: thin_star_out, count: 1 },
];

export default function GemsLayer({bg}) {
    return (
        <div className="w-full max-w-xl mx-auto">
            <Gems gems={gemData} bg={bg} />
        </div>
    );
}
